import React, { Fragment } from "react";
import LoginbackGround from "../../components/views/LoginContainer/LoginbackGround";
import LoginPage from "../../components/views/LoginPage";
const Loginpage2 = () => {
  return <LoginbackGround log={<LoginPage></LoginPage>}></LoginbackGround>;
};

export default Loginpage2;
